<template>
  <div class="wrapper" v-gxxt-loading="showLoading" loading-text="1秒关闭loading">
    <h1>组件</h1>
    <div>
      <input type="text" id="copyId" value="fuzhivalue" />
      <button @click="copy('21212212')">复制</button>
    </div>
    <h2>=> tab</h2>
    <div>
      <gxxt-tab v-model="tabName" @tab-click="changeTab">
        <gxxt-tab-pane label="选项1" name="tab1">213213213</gxxt-tab-pane>
        <gxxt-tab-pane label="选项2" name="tab2" superscript="11">3213213</gxxt-tab-pane>
        <gxxt-tab-pane label="选项2" name="tab3">3213213</gxxt-tab-pane>
      </gxxt-tab>
    </div>
    <h2>=> 输入框</h2>
    <div class="p20">
      <gxxt-input required label="姓名" v-model="inputValue"></gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required outline label="姓名" v-model="inputValue"></gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required disabled label="禁用" v-model="inputValue"></gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required disabled label="前置slot" v-model="inputValue">
        <template v-slot:prefix>
          <i class="iconfont icon-fuzhi f30"></i>
        </template>
      </gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required clearable label="带清除" v-model="inputValue"></gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required disabled label="后置slot" v-model="inputValue">
        <template v-slot:suffix>
          <i class="iconfont icon-fuzhi f30"></i>
        </template>
      </gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required disabled label="禁用" v-model="inputValue">
        <template v-slot:prefix>
          <i class="iconfont icon-fuzhi f30"></i>
        </template>
      </gxxt-input>
    </div>
    <div class="p20">
      <gxxt-input required readonly label="只读" v-model="inputValue"></gxxt-input>
    </div>
    <div>
      <gxxt-circle-percent :size="96" :value="80" :total="100"></gxxt-circle-percent>
      <gxxt-circle-percent :size="96" :value="50" :total="100"></gxxt-circle-percent>
    </div>
    <h2>=> 按钮</h2>
    <div>
      <GxxtButton type="primary" @click="showToaster">打开toaster</GxxtButton>
    </div>
    <div>
      <GxxtButton type="primary">primary middle button</GxxtButton>
      <GxxtButton type="primary" size="large">primary large button</GxxtButton>
      <GxxtButton type="primary" size="small">primary small button</GxxtButton>
      <GxxtButton type="primary" size="xs">primary xs button</GxxtButton>
    </div>
    <div>
      <GxxtButton type="primary" disabled>primary button 禁用</GxxtButton>
    </div>
    <div>
      <GxxtButton round>round button</GxxtButton>
    </div>
    <div>
      <GxxtButton round disabled>round button 禁用</GxxtButton>
    </div>
    <div>
      <GxxtRadio class name="a">
        <span slot="icon">icon</span>
        微信支付
      </GxxtRadio>
    </div>
    <div>
      <GxxtRadio class="w600" name="a">
        <span slot="icon">icon</span>
        微信支付
      </GxxtRadio>
    </div>
    <div>
      <GxxtRadio name="a"></GxxtRadio>
    </div>
    <div>
      <GxxtRadio name="a" after>微信支付</GxxtRadio>
    </div>
    <h2>=> 标签</h2>
    <div class="p10">
      <gxxt-tag round size="small">小标签圆角</gxxt-tag>
    </div>
    <div class="p10">
      <gxxt-tag round size="middle" class="w400">中标签圆角自定义class</gxxt-tag>
    </div>
    <div class="p10">
      <gxxt-tag size="large" round color="#f60" text-color="#fff">large标签标签圆角自定义颜色</gxxt-tag>
    </div>
    <div class="p10">
      <gxxt-tag color="#FFF3ED" text-color="#f60">普通自定义颜色标签</gxxt-tag>
    </div>
    <h2>=> 设置数值</h2>
    <div>
      <input-number label="标签" @change="setChangeNum" v-model="num"></input-number>
    </div>
    <div>
      <input-number @change="setChangeNum" :max="6" :min="2" v-model="num2"></input-number>
    </div>
    <div>
      <pre>
        <code>
  &lt;input-number&gt; label="标签" @change="setChangeNum" v-model="num"&gt;&lt;/input-number&gt;
  &lt;input-number&gt; @change="setChangeNum" :max="6" :min="2" v-model="num2"&gt;&lt;/input-number&gt;
        </code>
      </pre>
    </div>
    <h2>=> Toast</h2>
    <div>
      <p class="f30" @click="open(1)">点我看效果 toaster提示框</p>
      <pre>
        <code>
          this.$toaster({
          message: '我是文字提示框',
          duration: 3000,
          show: true,
          })
        </code>
      </pre>
    </div>
    <div class="mt50">
      <p class="f30" @click="open(2)">点我看效果 $messageBox</p>
      <pre>
        <code>
          this.$messageBox({
          title: '您是否取消？',
          show: true,
          btnType: 2
          })
        </code>
      </pre>
    </div>
    <h2>=> rate 评分</h2>
    <div style="width: 300px">
      <gxxt-rate v-model="score"></gxxt-rate>
      <!-- 水平 -->
      <gxxt-rate show-score></gxxt-rate>
      <!-- 垂直 -->
      <gxxt-rate show-score direction="vertical"></gxxt-rate>
    </div>
    <h2>=> 进度</h2>
    <div style="width: 300px">
      <gxxt-progress v-model="progress"></gxxt-progress>
      <gxxt-progress :size="500" v-model="progress" show-progress></gxxt-progress>
    </div>
    <h2>=> 赞</h2>
    <div style="width: 300px">
      <gxxt-zan :value="zan" number="zanNum"></gxxt-zan>
      <gxxt-zan :value="zan" show-number></gxxt-zan>
    </div>
    <h2>=> 选择框</h2>
    <div>
      {{personnelObj}}
      <ios-select
        required
        :sourceData="scaleList"
        v-model="personnelObj"
        :level="1"
        label="人员规模"
        placeholder="选择人员规模"
        @change="changeScale"
      >
        <template v-slot:suffix>
          <i class="iconfont icon-gengduoyonghu"></i>
        </template>
      </ios-select>
    </div>
  </div>
</template>

<script>
import {
  GxxtRadio,
  GxxtTag,
  GxxtButton,
  GxxtCirclePercent,
  GxxtInput,
  GxxtRate,
  GxxtProgress,
  GxxtZan,
  GxxtTab,
  GxxtTabPane,
  GxxtIosSelect,
} from '@/components'
export default {
  components: {
    GxxtButton,
    GxxtRadio,
    GxxtTag,
    GxxtCirclePercent,
    GxxtInput,
    GxxtRate,
    GxxtProgress,
    GxxtZan,
    GxxtTab,
    GxxtTabPane,
  },
  data() {
    return {
      origin: '',
      showLoading: true,
      inputValue: '',
      score: 3.5,
      progress: 70,
      zan: true,
      zanNum: 100,
      num: 0,
      num2: 2,
      tabName: 'tab1',
      personnelObj: [],
      scaleList: [
        { id: 1, value: 'aaa' },
        { id: 2, value: 'bbb' },
        { id: 3, value: 'ccc' },
        { id: 4, value: 'ddd' },
        { id: 5, value: 'eee' },
      ],
    }
  },
  methods: {
    changeScale(v) {},
    setChangeNum(num) {
      console.log(num)
    },
    copy() {
      if (window.clipboardData) {
        return window.clipboardData.setData(
          'text',
          document.getElementById('copyId').value
        )
      }
      var save = function (e) {
        e.clipboardData.setData(
          'text/plain',
          document.getElementById('copyId').value
        )
        e.preventDefault()
      }
      document.getElementById('copyId').select()
      document.addEventListener('copy', save)
      // document.getElementById(id).select()
      document.execCommand('copy', false, null)
      document.removeEventListener('copy', save)
      this.$toaster({
        message: '复制成功',
        duration: 3000,
        show: true,
      })
      setTimeout(() => {
        document.getElementById('copyId').value = '22222'
      }, 500)
    },
    showToaster() {
      this.$toaster({
        message: '妥妥帖帖妥妥帖',
      })
    },
    open(i) {
      if (i == 1) {
        this.$toaster({
          message: '您当前所在的城市暂无',
          duration: 3000,
          show: true,
        })
      } else {
        this.$messageBox({
          title: '您当前所在的城市暂无',
          duration: 3000,
          show: true,
          btnType: 1,
        })
      }
    },
    changeTab(v) {
      console.log(v)
    },
  },
  created() {
    this.origin = this.$route.query.origin
  },
  mounted() {
    setTimeout(() => {
      this.showLoading = false
    }, 1000)
  },
}
</script>
<style lang="less" scoped>
* {
  text-align: left;
}
h1 {
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
}

h2 {
  font-size: 28px;
  font-weight: bold;
  padding: 20px;
  color: #333;
  font-weight: bold;
  background-color: #eee;
  margin: 30px 0;
}

.w600 {
  width: 600px;
}
.wrapper {
  padding-bottom: 100px;
  width: 100%;
  overflow: hidden;
}
</style>
